import { SERVICE_NAME } from "@/config/serviceNames";
import { EntityType, Module } from "@/constants";
import { requests } from ".";

const WordpressService = {
  // unsubscribeWordpress: (locationId: string) =>
  //   requests(SERVICE_NAME.WORDPRESS_API).post(
  //     `payments/location/${locationId}/unsubscribe`,
  //   ),

  // clearWordpressInstance: (locationId: string) =>
  //   requests(SERVICE_NAME.WORDPRESS_API).delete(
  //     `site/${locationId}/clear-wp-instance`
  //   ),

  // switchToUnlimitedMonthlyWordpressPlan: (payload: any) =>
  //   requests(SERVICE_NAME.WORDPRESS_API).post(
  //     "switch-standard-to-unlimited-monthly-plan",
  //     payload
  //   ),

  disableWordpressForAllLocations: (payload: any) =>
  requests(SERVICE_NAME.WORDPRESS_API)
  .log({
    module: Module.WORDPRESS,
    entityType: EntityType.COMPANY,
    entityId: payload.companyId,
  })
  .post(
    "support/disable-wordpress-offering-all-locations",
    payload
  ),      
    // requests(SERVICE_NAME.APPENGINE_API).post(
    //   "wordpress/support/disable_wp_all_locations",
    //   payload
    // ),

  getWordpressDetails: (locationId: string) =>
    requests(SERVICE_NAME.WORDPRESS_API)
    .log({
      module: Module.WORDPRESS,
      entityType: EntityType.LOCATION,
      entityId: locationId,
    })
    .post(`multisite/${locationId}/get-all`, { showDeleted: true }),

    getPrimaryDomain: (locationId: string, wpId: string) =>
    requests(SERVICE_NAME.WORDPRESS_API)
    .log({
      module: Module.WORDPRESS,
      entityType: EntityType.LOCATION,
      entityId: locationId,
    })
    .get(`domain/${locationId}/${wpId}/primary-domain`),
  
  fetchDomainDetails: (domain: string) =>
    requests(SERVICE_NAME.WORDPRESS_API)
    .log({
      module: Module.WORDPRESS,
      entityType: EntityType.OTHERS,
      entityId: domain,
    })
    .get(`support/domain-info/${domain}`),

  // getWordpressAgencyDetails: (query: string) =>
  //   requests(SERVICE_NAME.APPENGINE_API).get(
  //     `wordpress/support/wordpress_details?${query}`
  //   ),  

  // unsubscribeWordpressBySiteId: (locationId: string, siteId: string) =>
  //   requests(SERVICE_NAME.WORDPRESS_API)
  //   .log({
  //     module: Module.WORDPRESS,
  //     entityType: EntityType.LOCATION,
  //     entityId: locationId,
  //     documentId: siteId,
  //   })
  //   .delete(
  //     `support/unsubscribe/${locationId}/siteId/${siteId}`
  //   ),  
}

export default WordpressService;
